import { render } from "./ModalPrint.vue?vue&type=template&id=04c79b3e"
import script from "./ModalPrint.vue?vue&type=script&lang=js"
export * from "./ModalPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__